import { Box } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";

interface NavigationMenuItemsWrapperTabletProps {
  children: React.ReactNode;
}

export function NavigationMenuItemsWrapperTablet(props: NavigationMenuItemsWrapperTabletProps) {
  const { tu } = useTu("navigation");
  const { children } = props;

  return (
    <Box
      aria-label={tu("Navigation menu")}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "108px",
        flexShrink: 0,
        gap: 0.5,
        paddingY: 2,
        paddingX: 2,
        overflowY: "auto",
        maskImage:
          "linear-gradient(to bottom, transparent, black 16px, black calc(100% - 16px), transparent)",
      }}
    >
      {children}
    </Box>
  );
}
